import { Controller } from 'stimulus';
import jump from 'jump.js';

class Hero extends Controller {
  onDownClick() {
    const top = this.element.offsetTop + this.element.offsetHeight;
    const headerHeight = document.querySelector('.header')?.offsetHeight;

    jump(top - headerHeight);
  }
}

Hero.targets = [
  //
];

export default Hero;
